import styled from 'styled-components';

const PieModalHeader = styled.div`
  height: 56px;
  width: 100%;
`;

export default PieModalHeader;
